import "core-js/modules/es.object.to-string.js";
import dayjs from "dayjs";
export default {
  name: "SupplementRecordDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentId: {
      type: String,
      default: ''
    }
  },
  filters: {
    dateFormat: function dateFormat(value, format) {
      if (!value) return "";
      if (String(value).length === 10) {
        value = value * 1000;
      }
      return dayjs(value).format(format);
    }
  },
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      info: {}
    };
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.getInfo();
      }
    }
  },
  computed: {
    //被投诉人
    records: function records() {
      var _this$info;
      return ((_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.records) || [];
    },
    //信息
    complaint: function complaint() {
      return this.info.complaint || {};
    }
  },
  methods: {
    getInfo: function getInfo() {
      var _this = this;
      this.loading = true;
      this.$api.getComplaintDetail({
        id: this.currentId
      }).then(function (res) {
        _this.info = res.data || {};
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    handleResolve: function handleResolve() {
      this.$emit('update:visible', false);
      this.$emit('resolve', this.currentId);
    }
  }
};